/* CHARM — SCORE RING MARKUP

   Kept out of the engine so the ring can be reworked without touching quiz logic.
   window.charmQuizRing(pct) returns the markup; the engine calls it when present and
   falls back to a plain ring if this file has not loaded.

   The gradient uses userSpaceOnUse with its vector laid ALONG the arc's sweep rather
   than across the bounding box. With a box aligned gradient the visible arc sat
   entirely in the pale end and the ring read washed out. Laid along the sweep, the
   stroke starts as a light tint and deepens as it travels, which is what gives it the
   sense of filling with light.

   COLOUR RULE: the accent is #015CCF, sampled off the pendant indicator in the hero
   photograph. The gradient runs from tints of that hue DOWN TO the accent and stops
   there. It never goes past it. An earlier version ended on #0148A3, which is 8 L*
   below the accent and read as a different, darker blue.

     #9FD2FF  L* 82   tint
     #4E9CF3  L* 63   tint
     #1268D8  L* 46   tint
     #015CCF  L* 41   the accent itself, the deepest point on the arc

   The per cent sign lives INSIDE the figure element, not beside it. As a sibling its
   containing block was the ring, so left:100% threw it outside the circle entirely.
*/
(function () {
  'use strict';
  window.charmQuizRing = function (pct) {
    var R = 86, C = 2 * Math.PI * R;
    var target = C - (Math.max(0, Math.min(100, pct)) / 100) * C;
    var d = ' cx="110" cy="110" r="' + R + '" fill="none" stroke-linecap="round"' +
            ' stroke-dasharray="' + C.toFixed(2) + '" stroke-dashoffset="' + target.toFixed(2) + '"';
    var t = ' cx="110" cy="110" r="' + R + '" fill="none" stroke-linecap="round"';

    return '<div class="cq__ring" style="--circ:' + C.toFixed(2) + '; --target:' + target.toFixed(2) + ';">' +
      '<svg viewBox="0 0 220 220" aria-hidden="true">' +
        '<defs>' +
          '<linearGradient id="cqArcGrad" gradientUnits="userSpaceOnUse" x1="196" y1="96" x2="44" y2="186">' +
            '<stop offset="0%"   stop-color="#9FD2FF"/>' +
            '<stop offset="42%"  stop-color="#4E9CF3"/>' +
            '<stop offset="78%"  stop-color="#1268D8"/>' +
            '<stop offset="100%" stop-color="#015CCF"/>' +
          '</linearGradient>' +
        '</defs>' +
        '<circle class="cq__ring-track"' + t + '/>' +
        '<circle class="cq__ring-bleed"' + d + '/>' +
        '<circle class="cq__ring-body"'  + d + '/>' +
      '</svg>' +
      '<span class="cq__ring-num"><b>' + pct + '<i>%</i></b></span>' +
    '</div>';
  };
})();
